import 'bootstrap'
import './sass/main.scss'
import 'simplelightbox/dist/simple-lightbox'
import 'owl-carousel/owl-carousel/owl.carousel'

$(function() {
    console.log("Projekt oraz realizacja: Gruby Grafik");
    console.log("https://grubygrafik.pl");
    var pageTitle = $("title").text();
    $(window).blur(function() {
        $("title").text("🖨️ Wróć do nas | Graphic Media");
    });
    $(window).focus(function() {
        $("title").text(pageTitle);
    });
    $("button.hamburger").click(function(){
        $(this).toggleClass("is-active");
        $("nav").fadeToggle("fast");
    });
    $("nav ul li a").click(function(){
        $("nav").fadeToggle("fast");
        $("button.hamburger.is-active").removeClass("is-active");
    });
    $(".photo a").simpleLightbox();
    $(".product a").simpleLightbox();
});

$(document).ready(function(){
    var owl = $(".owl-carousel");
    owl.owlCarousel({
        nav: true,
        dots: true,
        items: 3,
        autoPlay: true,
        autoPlaySpeed: 500,
        margin: 15,
        autoplayHoverPause: true,
        responsive:{
            380:{
                items:1,
                nav:true
            },
            576:{
                items:1,
                nav:true
            },
            768:{
                items:2,
                nav:true
            },
            992:{
                items:3,
                nav:false
            }
        }
    });
    owl.trigger('owl.play',6000);
});

$("nav").find("a").click(function(e) {
    e.preventDefault();
    var section = $(this).attr("href");
    $("html, body").animate({
        scrollTop: $(section).offset().top
    });
});

var mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');

mapboxgl.accessToken = 'pk.eyJ1IjoiZ3J1YnlncmFmaWsiLCJhIjoiY2ptODczMDN3NGFsNDNwcXZmdjZyc2dvZSJ9.kYVNE8a8bArYmNmcV76r8w';
var map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/grubygrafik/cjoesy9050d512spepg98t6bk',
    center: [19.120710, 50.849560],
    zoom: 11.0
});
var framesPerSecond = 60;
var initialOpacity = 1
var opacity = initialOpacity;
var initialRadius = 6;
var radius = initialRadius;
var maxRadius = 18;

map.on('load', function () {

    // Add a source and layer displaying a point which will be animated in a circle.
    map.addSource('point', {
        "type": "geojson",
        "data": {
            "type": "Point",
            "coordinates": [
                19.120710, 50.849560
            ]
        }
    });

    map.addLayer({
        "id": "point",
        "source": "point",
        "type": "circle",
        "paint": {
            "circle-radius": initialRadius,
            "circle-radius-transition": {duration: 0},
            "circle-opacity-transition": {duration: 0},
            "circle-color": "#ff005a"
        }
    });

    map.addLayer({
        "id": "point1",
        "source": "point",
        "type": "circle",
        "paint": {
            "circle-radius": initialRadius,
            "circle-color": "#ff005a"
        }
    });


    function animateMarker(timestamp) {
        setTimeout(function(){
            requestAnimationFrame(animateMarker);

            radius += (maxRadius - radius) / framesPerSecond;
            opacity -= ( .9 / framesPerSecond );

            map.setPaintProperty('point', 'circle-radius', radius);
            map.setPaintProperty('point', 'circle-opacity', opacity);

            if (opacity <= 0) {
                radius = initialRadius;
                opacity = initialOpacity;
            }

        }, 1000 / framesPerSecond);

    }

    // animateMarker(0);
    map.scrollZoom.disable();
});
map.dragRotate.disable();
map.touchZoomRotate.disableRotation();